export default __webpack_public_path__ + "static/media/808.185ebe76.png";